module.exports = __webpack_public_path__ + "img/icon-1.42116180.svg";